import { render } from "./HomeSwip.vue?vue&type=template&id=7634809c&scoped=true"
import script from "./HomeSwip.vue?vue&type=script&lang=js"
export * from "./HomeSwip.vue?vue&type=script&lang=js"

import "./HomeSwip.vue?vue&type=style&index=0&id=7634809c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7634809c"]])

export default __exports__